import { FC } from "react";
import { ReactComponent as ErrorInfoIconSvg } from "../../assets/images/error-info-icon.svg";
import { ErrorInfoIconWrapper } from "./ErrorInfoIcon.style";
import { COMPONENT_IDS } from "../../helpers/constants/componentIds";
import { useNavigationSiteCore } from "../../hooks/useNavigationSiteCore";

type ErrorInfoIconProps = {
  onToggleToolTip: () => void;
  shouldDisableInfoIcon?: boolean;
  errorIconClassName?: string;
};

export const ErrorInfoIcon: FC<ErrorInfoIconProps> = ({
  onToggleToolTip,
  shouldDisableInfoIcon = false,
  errorIconClassName,
}) => {
  const { commonARIALabel } = useNavigationSiteCore();
  return (
    <ErrorInfoIconWrapper
      data-testid={COMPONENT_IDS.ERROR_INFO_ICON}
      onClick={onToggleToolTip}
      className={`error-info-icon ${errorIconClassName}`}
      role="img"
      tabIndex={0}
      aria-label={commonARIALabel.readMore}
    >
      <ErrorInfoIconSvg opacity={shouldDisableInfoIcon === true ? 0.5 : 1} />
    </ErrorInfoIconWrapper>
  );
};
